import type React from "react";
import { ReactComponent as Svg } from "./assets/bet-combo.svg";
import * as styles from "./Icon.module.scss";

type BetComboProps = React.SVGProps<SVGSVGElement>;

export const BetCombo = ({ className, ...props }: BetComboProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
